import { FiPlay as Play } from 'react-icons/fi';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import { ui } from '../constants';
import type { FeatureHint } from '../types';

interface HintBadgeProps {
  hint: FeatureHint;
}

function HintBadge({ hint }: HintBadgeProps) {
  const hintType = hint?.type || 'text';
  const description = hint?.description || '';
  const descriptionHasVideo = /<video[\s>]/i.test(description);

  if (!description) {
    return null;
  }

  const tooltipContent =
    hintType === 'video' && hint.videoUrl && !descriptionHasVideo ? (
      <>
        <span dangerouslySetInnerHTML={{ __html: description }} />
        <video
          className="hint-tooltip-video rounded-2"
          src={hint.videoUrl}
          controls
          muted
          playsInline
          preload="metadata"
        />
        <strong className="hint-video-label">{ui.common.hintVideoLabel}</strong>
      </>
    ) : (
      <span dangerouslySetInnerHTML={{ __html: description }} />
    );

  if (hintType === 'video') {
    return (
      <ChildrensTooltip
        html={tooltipContent}
        placement="top"
        showOnHover={false}
        noChildSpan
      >
        <span className="hint-badge hint-badge-video fs--2 rounded-circle" role="button" tabIndex={0}>
          <Play size={10} fill="currentColor" />
        </span>
      </ChildrensTooltip>
    );
  }

  return (
    <HelpTooltip
      html={tooltipContent}
      placement="top"
      showOnHover={false}
      className="hint-help-tooltip"
    />
  );
}

export default HintBadge;
